export function validateYouTubeUrl(url) {
  if (!url) return false;
  // Regular expression pattern for validating YouTube URLs
  var youtubePattern =
    /(youtube\.com|youtu\.be|m\.youtube\.com)\/(watch\?(v=|app=)|v\/)?/;

  // Test if the URL matches the YouTube pattern
  var match = url.match(youtubePattern);

  // Check if there's a match and return true or false accordingly
  return !!match;
}

export async function validateVimeoUrl(url) {
  if (!url) return false;

  const res = await fetch(`https://vimeo.com/api/oembed.json?url=${url}`);
  if (!res.ok) return false;

  const json = await res.json();
  return json?.video_id ? true : false;
}

export async function validateVideoLink(url) {
  if (!url) return false;

  const isValidYoutubeLink = validateYouTubeUrl(url);
  if (isValidYoutubeLink) return true;

  const isValidVimeoLink = await validateVimeoUrl(url);
  return isValidVimeoLink;
}
